import axios from 'axios'

export default {
    namespaced: true,
    state: {
        workTypes: [],
        workTypesHotel: [],
    },
    mutations: {
        CLEAR_DATA(state) {
            state.workTypes = [],
            state.workTypesHotel = []
        },
        FETCH_WT(state, payload) {
            state.workTypes = payload
        },
        FETCH_WTI(state, payload) {
            state.workTypesHotel = payload
        },
        ADD_WT(state, payload) {
            const index = state.workTypes.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.workTypes[index], payload)
            } else {
                state.workTypes.push(payload)
            }
        },
        ADD_WTH(state, payload) {
            const index = state.workTypesHotel.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.workTypesHotel[index], payload)
            } else {
                state.workTypesHotel.push(payload)
            }
        },
        DEL_WT(state, payload) {
            const index = state.workTypes.findIndex(
                item => item.id === payload
            )
            if (index !== -1) {
                state.workTypes.splice(index, 1)
            }
        },
        DEL_WTH(state, payload) {
            state.workTypesHotel = state.workTypesHotel.filter(item => {
                if (item && item.pivot && item.pivot.hotel_id) {
                     return !(item.id === payload.work_type_id && item.pivot.hotel_id === payload.hotel_id);
                } else {
                    return true;
                }
            });
        },
    },
    actions: {
        fetch({commit, dispatch, state}) {
            return new Promise((resolve, reject) => {
                if (state.workTypes.length) {
                    resolve()
                } else {
                    axios.get(
                        '/api/mixins/work-types/lists'
                    ).then(({data}) => {
                        commit('FETCH_WT', data.data)
                        resolve()
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        fetchWTH({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/work-types/listId', { params: filter }
                ).then(({data}) => {
                    const filteredData = data.data.filter(item => item.room_types.some(room => room.pivot.hotel_id === filter.hotel_id));
                    commit('FETCH_WTI', filteredData);
                    commit('TOGGLE_PRELOADER', false, {root: true})
                    resolve(filteredData)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        add({ dispatch, commit }, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/mixins/work-types/add',
                    data
                ).then(({ data }) => {
                    commit('ADD_WT', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        addWTH({ dispatch, commit }, { data, hotel_id }) {
            return new Promise((resolve) => {
                axios.post('/api/mixins/work-types/add-wth',
                    data
                ).then(({ data }) => {
                    data.data.room_types = data.data.room_types.filter(room => room.pivot && room.pivot.hotel_id === hotel_id);
                    commit('ADD_WTH', data.data);
                    resolve();
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        delete({dispatch, commit}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/mixins/work-types/dell/' + itemId,
                ).then(({data}) => {
                    commit('DEL_WT', itemId)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        deleteWTH({ dispatch, commit }, { work_type_id, hotel_id }) {
            return new Promise((resolve) => {
                axios.post(`/api/mixins/work-types/delete`, {
                    work_type_id,
                    hotel_id,
                    _method: 'DELETE'
                }).then(({ data }) => {
                    commit('DEL_WTH', { work_type_id, hotel_id })
                    resolve();
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        getCheckLists({dispatch}) {
            return new Promise((resolve, reject) => {
                axios.get(
                    '/api/mixins/work-types/check-lists'
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        }
    }
}
